import { isImageField } from '@/domain/image/isImageField';
import type { AField } from '@/domain/field/AField';

// A mask zone (devis complémentaire n°2): an image field whose url lives in this folder. It is
// not printed; wherever it lies, it makes transparent what the stack holds under it (motif, image,
// shape, text). Kept in domain/image so the engine, the layers and the panels read the same marker.
const MASK_ZONE_FOLDER = '/catalog/masks/';

type TMaskShape = 'rectangle' | 'rond' | 'triangle';

// `includes`, not `startsWith`: an image element reports its url resolved against the page.
function isMaskUrl(url: string | undefined): boolean {
    return url?.includes(MASK_ZONE_FOLDER) === true;
}

function isMaskField(field: AField | undefined): boolean {
    return isImageField(field) && isMaskUrl(field.url);
}

// 'masque-rond.svg' → 'rond'. Unknown files read as a rectangle, the safest outline.
function maskShapeOf(url: string | undefined): TMaskShape {
    if (url?.includes('masque-rond')) {
        return 'rond';
    }
    if (url?.includes('masque-triangle')) {
        return 'triangle';
    }
    return 'rectangle';
}

export { isMaskField, isMaskUrl, MASK_ZONE_FOLDER, maskShapeOf };
export type { TMaskShape };
